module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2015/november-5a2f3d5b892a831b64423e9a895c6d0b.png";